import axios, { AxiosRequestConfig, AxiosRequestHeaders } from 'axios'

import { responseDataHasError } from '@/config/http/http.helpers'
import { readFromLocalStorage } from '@/services/localStorage'

export const BASE_URL = import.meta.env.VITE_API_BASE_URL as string

const timeout = parseInt(import.meta.env.VITE_API_TIMEOUT as string)

const http = axios.create({
  baseURL: BASE_URL,
  timeout,
  headers: {
    'Content-Type': 'application/json'
  }
})

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  skipAuth?: boolean
  noAuth?: boolean
  headers: AxiosRequestHeaders
}

http.interceptors.request.use((config: CustomAxiosRequestConfig) => {
  if (config.skipAuth) {
    return config
  }
  if (!config.noAuth) {
    const token = readFromLocalStorage('token')
    if (token) {
      config.headers['Authorization'] = token
    } else {
      delete config.headers['Authorization']
    }
  }
  return config
})

http.interceptors.response.use(response => {
  if (responseDataHasError(response.data)) return Promise.reject(response.data)

  return response
})

export default http
